export default class UserService {
    constructor(
        $http,
        CONSTANTS, $state
    ) {
        'ngInject';

        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.state = $state;
    }

    get = () => {
        return this.$http.get('https://jsonplaceholder.typicode.com/users')
            .then((response) => {
                return response.data;
            });
    };

    /*  callAPI = (endpoint, method, args, callback) => {
         var url = this.CONSTANTS.NODE_URL + endpoint;


         this.$http.defaults.headers.post["Content-Type"] = "application/json";
         this.$http.defaults.headers.post["x-auth-token"] = "tq355lY3MJyd8Uj2ySzm"
         this.$http.defaults.headers.post["x-auth-userid"] = "44B7TvzRTZkpdxs9u"

         return this.$http({
                 url: url,
                 method: "POST",
                 data: JSON.stringify(args)

             })
             .then(function(response) {
                     return response;
                 },
                 function(response) { // optional
                     return response;
                 });
     } */


    callAPI(endpoint, method, args, callback) {
        try {
            var url = this.CONSTANTS.NODE_URL + endpoint;
            //var url = endpoint;
            console.log(url)
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    let resultObj = {
                        "result": undefined,
                        "error": undefined
                    };
                    try {
                        resultObj.result = JSON.parse(xhttp.responseText);
                        callback(resultObj);
                    } catch (error) {
                        resultObj.error = "Bad Request - End Point is invalid";
                        callback(resultObj);
                    }
                } else {
                    if (this.readyState == 4) {
                        let resultObj = {
                            "result": undefined,
                            "error": undefined
                        };
                        resultObj.error = JSON.parse(xhttp.responseText);
                        callback(resultObj);
                    }
                }
            };
            xhttp.open(method, url, true);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
            xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");
            xhttp.onerror = function(e) {
                let resultObj = {
                    "result": undefined,
                    "error": undefined
                };
                resultObj.error = "Bad Request - Server is Down";
                callback(resultObj);
            };
            if (args != undefined) {
                xhttp.send(JSON.stringify(args));
            } else {
                xhttp.send();
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    callRabbitMQAPI(endpoint, method, args, callback) {
        try {
            console.log("rabbitMq log Push.....")
            var url = this.CONSTANTS.NODE_URL + endpoint;
            //var url = endpoint;
            console.log(url)
            var xhttp = new XMLHttpRequest();
            // xhttp.onreadystatechange = function() {
            //    // callBack
            // };
            xhttp.open(method, url, true);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
            xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");
            // xhttp.onerror = function(e) {
            //     let resultObj = {
            //         "result": undefined,
            //         "error": undefined
            //     };
            //     resultObj.error = "Bad Request - Server is Down";
            //     callback(resultObj);
            // };
            if (args != undefined) {
                xhttp.send(JSON.stringify(args));
            } else {
                xhttp.send();
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    downloadAPI(endpoint, method, args, callback) {
        try {
            var url = this.CONSTANTS.NODE_URL + endpoint;
            var xhttp = new XMLHttpRequest();

            xhttp.onload = function() {
                let resultObj = {
                    "result": undefined,
                    "error": undefined
                };

                if (this.status >= 200 && this.status < 300) {
                    const disposition = xhttp.getResponseHeader("content-disposition");
                    let fileName = "download";
                    const matchedFileName = disposition && disposition.match(/filename="?([^"]+)"?/);

                    if (matchedFileName && matchedFileName[1]) {
                        fileName = matchedFileName[1];
                    }

                    resultObj.result = {
                        data: xhttp.response,
                        fileName: fileName
                    };
                } else {
                    resultObj.error = {
                        status: this.status,
                        message: "Unable to download file"
                    };
                }

                callback(resultObj);
            };

            xhttp.onerror = function() {
                callback({
                    "result": undefined,
                    "error": {
                        message: "Bad Request - Server is Down"
                    }
                });
            };

            xhttp.open(method, url, true);
            xhttp.responseType = "blob";
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
            xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");

            if (args != undefined) {
                xhttp.send(JSON.stringify(args));
            } else {
                xhttp.send();
            }
        } catch (ex) {
            console.log(ex);
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/user/user.service.js